/**
 * @class
 * @description Wrapper class that injects our modified hlsjs loader in a videojs instance
 * @exports VideoJs
 */
export default class VideoJs {
    /**
     * Constructs VideoJs adapter.
     * @param {Object} player VideoJs player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        setTimeout(() => {
            var _a;
            try {
                if ((_a = player.tech_) === null || _a === void 0 ? void 0 : _a.vhs) {
                    new (VideoJs._adapters.getLoaders().LoaderVhs)();
                }
                else if (player.dash && player.dash.mediaPlayer && !player.dash.shakaPlayer) {
                    // dash
                    new (VideoJs._adapters.getLoaders().LoaderDash)(player.dash.mediaPlayer);
                    VideoJs._adapters.getLoaders().LoaderDash._engine.setManifestResource(player.dash.mediaPlayer.getSource());
                }
            }
            catch (e) {
                console.error(e);
            }
        }, 150);
        // by default use hlsjs
        player.options_.html5 = {
            hlsjsConfig: {
                loader: VideoJs._adapters.getLoaders().LoaderHlsjs
            }
        };
    }
}
